import React from 'react';
import { Menu } from '../../../components/Menu';
import { Wrapper, Content } from './styles';
import { usePages } from '../../../hooks/Pages';
import FooterLayout from '../../Footer';
import PopupComponent from '../../../components/PopupContainer';
 

const AuthLayout: React.FC = ({ children }) => {
  const { menu } = usePages();
  return (<>
    <Wrapper>
      <Menu menuList={menu} fixedMenu={false} />
      <Content>{children}</Content>
     
      <PopupComponent />
 
    </Wrapper>
     <FooterLayout />
    </>
  );
};

export default AuthLayout;
